import { Tooltip } from "@mui/material";
import SaveIcon from "@mui/icons-material/Save";

import {useAuth} from "../../hooks/useAuthProvide";
import { ButtonCustom } from "../../Theme/ButtonStyle";
import { TextAdapterCustom } from "../../Theme/TextStyle";
import { formatDateForServer } from "../../lib/Utility";

const REACT_APP_API_BASE_URL = (window._env_ && window._env_.API_URL) ? window._env_.API_URL + '/api/cc/' : process.env.REACT_APP_API_BASE_URL;

export default function DownloadReport(props) {

  const {
    type,
    siteID,
    categoryID,
    reportFromDate,
    reportToDate,
    selectedFrequency,
    checkedVariables,
    // classes
  } = props

  const {sessionToken} = useAuth();

  const renderButton =() => {

    return (
    <ButtonCustom
          color="primary"
          startIcon={<SaveIcon />}
          type="submit"
          disabled={checkedVariables.length === 0}
          className={"download-report-button"}>
      <TextAdapterCustom>
          Download report
      </TextAdapterCustom>
    </ButtonCustom>
  )};

  const typePDF = type === "HACCP" ? "timelinepdfgen" : "differencepdfgen"

  return (
    <form method="post" action={REACT_APP_API_BASE_URL + typePDF} target="_blank">
      <input type="hidden" name="sessionToken" value={sessionToken} />
      <input type="hidden" name="typeReport" value={type} />
      <input type="hidden" name="siteID" value={siteID} />
      <input type="hidden" name="categoryID" value={categoryID} />
      <input type="hidden" name="dateStart" value={formatDateForServer(reportFromDate.toISOString())} />
      <input type="hidden" name="dateEnd" value={formatDateForServer(reportToDate.toISOString())} />
      <input type="hidden" name="step" value={selectedFrequency} />
      {checkedVariables.map(variableId => (
        <input key={variableId} type="hidden" name="ids" value={variableId} />
      ))}
      {checkedVariables.length === 0 && (
        <Tooltip title="Seleziona almeno una variabile" arrow>
            {renderButton()}
        </Tooltip>
      )}
      {checkedVariables.length > 0 && renderButton()}
    </form>
  );
}
